export default __webpack_public_path__ + "static/media/criticalRW.e51b5b72.png";